import script from "./DomainFileListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainFileListItem.vue?vue&type=script&setup=true&lang=js"

import "./DomainFileListItem.vue?vue&type=style&index=0&id=b9bcd258&scoped=true&lang=css"
import "./DomainFileListItem.vue?vue&type=style&index=1&id=b9bcd258&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9bcd258"]])

export default __exports__